export default class SelfAdjustingTimer {
    constructor(callback, interval) {
        this.expected = undefined;
        this.timeout = undefined;
        this.interval = interval;
        this.callbackFn = callback;
    }
    start = () => {
        this.expected = Date.now() + this.interval;
        this.timeout = setTimeout(this.step, this.interval);
    };
    stop = () => {
        clearTimeout(this.timeout);
        this.timeout = 0;
    };
    step = () => {
        const drift = Date.now() - this.expected;
        this.callbackFn();
        this.expected += this.interval;
        this.timeout = setTimeout(this.step, Math.max(0, this.interval - drift));
    };
}
